import React from "react";

/**
 * Step 2
 * Component to show processing of Excel files.
 */
const Processing = ({
  step = 1,
  setStep = "",
  details = [],
  setDetails = "",
}) => {
  return (
    <center>
      <div
        style={{ border: "1px solid grey", padding: "1%", color: "#393186" }}
      >
        <h4>Thank You for uploading your file.</h4>
        <h4>We will update once the file is processed.</h4>
      </div>
    </center>
  );
};

export default Processing;
